
import NewsAndGuidesArticle from '~/components/NewsAndGuidesArticle.vue'

export default {
  components: { NewsAndGuidesArticle },

  async asyncData({ $prismic, params, error }) {
    try {
      const document = await $prismic.api.getByUID(
        'news_and_guides',
        params.slug,
        { fetchLinks: 'categories.category' }
      )

      const prevArticle = (
        await $prismic.api.query('[at(document.type, "news_and_guides")]', {
          pageSize: 1,
          after: `${document.id}`,
          orderings:
            '[my.news_and_guides.publish_date_override desc, document.last_publication_date desc]',
        })
      ).results[0]

      const nextArticle = (
        await $prismic.api.query('[at(document.type, "news_and_guides")]', {
          pageSize: 1,
          after: `${document.id}`,
          orderings:
            '[my.news_and_guides.publish_date_override, document.last_publication_date]',
        })
      ).results[0]

      const { results } = await $prismic.api.query(
        [
          '[at(document.type, "news_and_guides")]',
          `[at(my.news_and_guides.category, "${document.data.category.id}")]`,
        ],
        {
          fetchLinks: 'categories.category',
          orderings:
            '[my.news_and_guides.publish_date_override desc, document.last_publication_date desc]',
          pageSize: 4,
        }
      )

      const similarArticles = results
        .filter((article) => article.id !== document.id)
        .slice(0, 3)

      return {
        document,
        similarArticles,
        prevArticle,
        nextArticle,
      }
    } catch (e) {
      error({ statusCode: 404, message: 'Page not found' })
    }
  },

  head() {
    return {
      title: `${this.document.data.title} | Nurole board-level recruitment`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            this.document.data.meta_description || this.document.data.subtitle,
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content:
            this.document.data.meta_description || this.document.data.subtitle,
        },
      ],
    }
  },
}
